import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['button', 'content'];

  static classes = ['buttonActive', 'buttonInactive', 'contentActive', 'contentInactive'];

  static values = {
    initialIndex: { type: Number, default: 0 },
  };

  connect() {
    // activate initial option
    if (this.hasButtonTarget && this.buttonTargets.length > 0) {
      const initialIndex = Math.min(this.initialIndexValue, this.buttonTargets.length - 1);
      this.switchTo(initialIndex);
    }
  }

  switchTo(index) {
    // update all buttons
    this.buttonTargets.forEach((button, i) => {
      if (i === index) {
        if (this.hasButtonActiveClass) button.classList.add(...this.buttonActiveClasses);
        if (this.hasButtonInactiveClass) button.classList.remove(...this.buttonInactiveClasses);
      } else {
        if (this.hasButtonActiveClass) button.classList.remove(...this.buttonActiveClasses);
        if (this.hasButtonInactiveClass) button.classList.add(...this.buttonInactiveClasses);
      }
    });

    // update all content
    this.contentTargets.forEach((content, i) => {
      if (i === index) {
        if (this.hasContentActiveClass) content.classList.add(...this.contentActiveClasses);
        if (this.hasContentInactiveClass) content.classList.remove(...this.contentInactiveClasses);
      } else {
        if (this.hasContentActiveClass) content.classList.remove(...this.contentActiveClasses);
        if (this.hasContentInactiveClass) content.classList.add(...this.contentInactiveClasses);
      }
    });

    this.dispatch('switched', { detail: { index, button: this.buttonTargets[index], content: this.contentTargets[index] } });
  }

  select(event) {
    const button = event.currentTarget;
    const index = this.buttonTargets.indexOf(button);
    if (index !== -1) this.switchTo(index);
  }
}
